/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  OutlinedInput,
  Stack,
  styled,
  TextField,
  Typography,
  useTheme,
  IconButton,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Radio,
  AutocompleteRenderOptionState,
  AutocompleteRenderGetTagProps
} from '@mui/material';
import {
  ChangeEvent,
  FC,
  ReactNode,
  SyntheticEvent,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { withStyles } from '@mui/styles';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import {
  initialState,
  reducerUpdateAdvanceSearch,
  reducerUpdateCommentingToPostDateRange,
  reducerUpdateCommentingToPostLabelList
} from 'src/features/advanceSearchEcommerce';
import {
  IGranularity,
  ILabel,
  IRawPostmadeOutputEntity,
  IRawPostmadeOutputWithPagination,
  TContentType,
  TStringOperator,
  TPostOwnership,
  TSentiment,
  TValidation,
  ILanguage,
  TTalkType,
  IDateRange
} from 'src/models/general';
import CheckboxCustomNl, { ChipCustom } from './CheckboxCustomNl';
import ModalSelectLabel from '../ModalSelectLabel';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDebounce } from 'src/hooks/useDebounce';
import { useLazyQuery, useQuery } from '@apollo/client';
import { fillParamAdvanceSearchEmpty } from 'src/utils/fillParamAdvanceSearchEmpth';
import { GET_POSTMADE_STREAM_ID } from 'src/services/graphql/content/query';
import CheckIcon from '@mui/icons-material/Check';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import { RadioButtonChecked } from '@mui/icons-material';
import { correctDoubleSpaces } from 'src/utils/correctDoubleSpaces';
import { GET_LANGUAGES_V2 } from 'src/services/graphql/stream/query';
import { useAlert } from 'src/hooks/useAlert';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import ModalCustomTimeFrame from '../ModalCustomTimeFrame';
import TableCommentingToProduct from './TableCommentingToProduct';
import useEcommerce from 'src/services/useEcommerce';
import { IEcommerceProductHierarchyItem } from 'src/models/ecommerce';

interface Props {
  open: boolean;
  onClose: () => void;
  objectIdList?: string[];
}

interface IOptionSentimentCheckbox {
  id: TSentiment;
  name: TSentiment;
  label: string;
  isChecked: boolean;
}

interface IOptionStreamTypeCheckbox {
  id: TPostOwnership;
  name: TPostOwnership;
  label: string;
  isChecked: boolean;
}

export interface IOptionTalkTypeCheckbox {
  id: TTalkType;
  name: TTalkType;
  label: string;
  isChecked: boolean;
}

export interface IOptionValidationCheckbox {
  id: TValidation;
  name: TValidation;
  label: string;
  isChecked: boolean;
}

interface IOptionPostTypeCheckbox {
  id: TContentType;
  name: TContentType;
  label: string;
  isChecked: boolean;
}

export interface IOptionRatingCheckbox {
  id: number;
  name: number;
  label: string;
  isChecked: boolean;
}

type TAccordion = 'more_filters' | 'commenting_to_post' | 'confidence_score';

const CustomAutocomplete = withStyles({
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"] .MuiAutocomplete-input':
      {
        padding: 0
      }
  }
})((props: any) => <Autocomplete {...props} />);

const CustomInput = withStyles((theme) => ({
  root: {
    borderRadius: '4px 0px 0px 4px',
    height: theme.spacing(5)
  }
}))(OutlinedInput);

const FabSmall = styled(Fab)(
  ({ theme }) => `
    min-height: unset;
    background-color: transparent;
    width: ${theme.spacing(3)};
    height: ${theme.spacing(3)};
    color: #E35200;
    border: 1px solid #E35200;

  `
);

const AdvanceSearchEcommerce: FC<Props> = ({
  open,
  onClose,
  objectIdList: objectIdListLocal
}) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { useGetEcommerceStreamCommentingToProduct } = useEcommerce();
  const projectId = useAppSelector((state) => state.users.project.id);
  const labelEcommerce = useAppSelector(
    (state) => state.storeLabel.labelEcommerce
  );

  const [expanded, setExpanded] = useState<TAccordion>('more_filters');

  const handleChangeAccordion =
    (panel: TAccordion) =>
    (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : 'more_filters');
    };

  const [anchorElLabelInclude, setAnchorElLabelInclude] =
    useState<HTMLDivElement | null>(null);

  const [anchorElLabelExclude, setAnchorElLabelExclude] =
    useState<HTMLDivElement | null>(null);

  const [
    anchorElLabelIncludeCommentingToPost,
    setAnchorElLabelIncludeCommentingToPost
  ] = useState<HTMLDivElement | null>(null);

  const handleClickLabelIncludeCommentingToPost = (event: any) => {
    setAnchorElLabelIncludeCommentingToPost(event.currentTarget);
  };

  const handleCloseLabelIncludeCommentingToPost = function () {
    setAnchorElLabelIncludeCommentingToPost(null);
  };

  const handleClickLabelInclude = (event: any) => {
    setAnchorElLabelInclude(event.currentTarget);
  };

  const handleCloseLabelInclude = function () {
    setAnchorElLabelInclude(null);
  };

  const handleClickLabelExclude = (event: any) => {
    setAnchorElLabelExclude(event.currentTarget);
  };

  const handleCloseLabelExclude = function () {
    setAnchorElLabelExclude(null);
  };

  const openLabelInclude = Boolean(anchorElLabelInclude);
  const openLabelExclude = Boolean(anchorElLabelExclude);
  const openLabelIncludeCommentingToPost = Boolean(
    anchorElLabelIncludeCommentingToPost
  );

  const {
    includeKeywords,
    excludeKeywords,
    sentiment,
    fromUsername,
    postOwnership,
    validationList,
    contentTypeList,
    labelList,
    excludeLabelList,
    sentimentConfidenceLevelMin,
    sentimentConfidenceLevelMax,
    showEmptyLabel,
    streamsCommentingToPost,
    selectedOriginalToPost,
    queryStringBooleanOperator,
    languageList,
    userRating,
    selectAllPrimaryPost,
    talkType,
    replyToOriginalId,
    commentingToPostDateRange,
    commentingToPostLabelList
  } = useAppSelector((state) => state.storeAdvancedSearchEcommerce);

  const [selectAllPrimaryLocal, setSelectAllPrimaryLocal] =
    useState(selectAllPrimaryPost);

  const { handleClickAlert } = useAlert();

  const { data: languages, loading: loadingLanguages } = useQuery<{
    languages_getLanguagesV2: ILanguage[];
  }>(GET_LANGUAGES_V2, {
    fetchPolicy: 'cache-first',
    onError: () => {
      handleClickAlert({
        horizontal: 'center',
        vertical: 'top',
        message: 'Error fetching languages',
        severity: 'error'
      });
    }
  });

  const isValueAvailable = function <T>(values: Array<T>, valString: T) {
    const value = values.find((value: T) => value === valString);
    return value ? true : false;
  };

  const isPositiveChecked = isValueAvailable<TSentiment>(sentiment, 'positive');
  const isNeutralChecked = isValueAvailable<TSentiment>(sentiment, 'neutral');
  const isNegativeChecked = isValueAvailable<TSentiment>(sentiment, 'negative');

  const isTalkChecked = isValueAvailable<TPostOwnership>(postOwnership, 'talk');
  const isReplyChecked = isValueAvailable<TPostOwnership>(
    postOwnership,
    'reply'
  );

  const isValidationChecked = isValueAvailable<TValidation>(
    validationList,
    'validated'
  );
  const isUnValidatedChecked = isValueAvailable<TValidation>(
    validationList,
    'unvalidated'
  );

  const isContentTextChecked = isValueAvailable<TContentType>(
    contentTypeList,
    'text'
  );
  const isContentImageChecked = isValueAvailable<TContentType>(
    contentTypeList,
    'image'
  );
  const isContentVideoChecked = isValueAvailable<TContentType>(
    contentTypeList,
    'video'
  );
  const isContentOthersChecked = isValueAvailable<TContentType>(
    contentTypeList,
    'others'
  );

  const isPostChecked = isValueAvailable<TTalkType>(talkType, 'post');

  const isCommentChecked = isValueAvailable<TTalkType>(talkType, 'comment');

  const isRepostChecked = isValueAvailable<TTalkType>(talkType, 'repost');

  const [includeKeywordsLocal, setIncludeKeywordsLocal] =
    useState<Array<string>>(includeKeywords);

  const [excludeKeywordsLocal, setExcludeKeywordsLocal] =
    useState<Array<string>>(excludeKeywords);

  const [usernameLocal, setUsernameLocal] = useState<string>(fromUsername);

  const getInitLanguages = () => {
    if (!languages || languageList.length <= 0) return [];
    return languages.languages_getLanguagesV2.filter((language) =>
      languageList.includes(language.language)
    );
  };

  const [languageListLocal, setLanguageListLocal] =
    useState<ILanguage[]>(getInitLanguages);

  const labels = useAppSelector((state) => state.storeLabel.labelList.data);
  const initialIncludeLabels = labels.filter((label) =>
    labelList?.includes(label.id)
  );
  const initialExcludeLabels = labels.filter((label) =>
    excludeLabelList?.includes(label.id)
  );
  const [includeLabelListLocal, setIncludeLabelListLocal] =
    useState<Array<ILabel>>(initialIncludeLabels);

  const [includeLabelCommentingToPost, setIncludeLabelCommentingToPost] =
    useState<ILabel[]>(commentingToPostLabelList);

  const [excludeLabelListLocal, setExcludeLabelListLocal] =
    useState<Array<ILabel>>(initialExcludeLabels);

  const [selectedProductsLocal, setSelectedProductsLocal] = useState<
    Array<IEcommerceProductHierarchyItem>
  >(selectedOriginalToPost);

  const [
    sentimentConfidenceLevelMinLocal,
    setSentimentConfidenceLevelMinLocal
  ] = useState<number>(sentimentConfidenceLevelMin);

  const [
    sentimentConfidenceLevelMaxLocal,
    setSentimentConfidenceLevelMaxLocal
  ] = useState<number>(sentimentConfidenceLevelMax);

  const [showEmptyLabelLocal, setShowEmptyLabelLocal] =
    useState<boolean>(showEmptyLabel);

  const [sentimentOptions, setSentimentOptions] = useState<
    Array<IOptionSentimentCheckbox>
  >([
    {
      id: 'positive',
      name: 'positive',
      label: 'Positive',
      isChecked: isPositiveChecked
    },
    {
      id: 'neutral',
      name: 'neutral',
      label: 'Neutral',
      isChecked: isNeutralChecked
    },
    {
      id: 'negative',
      name: 'negative',
      label: 'Negative',
      isChecked: isNegativeChecked
    }
  ]);

  const [streamTypeOptions, setStreamTypeOptions] = useState<
    Array<IOptionStreamTypeCheckbox>
  >([
    {
      id: 'talk',
      name: 'talk',
      label: 'Talk',
      isChecked: isTalkChecked
    },
    {
      id: 'reply',
      name: 'reply',
      label: 'Reply',
      isChecked: isReplyChecked
    }
  ]);

  const [talkTypeOptions, setTalkTypeOptions] = useState<
    Array<IOptionTalkTypeCheckbox>
  >([
    {
      id: 'post',
      name: 'post',
      label: 'Post',
      isChecked: isPostChecked
    },
    {
      id: 'comment',
      name: 'comment',
      label: 'Comment',
      isChecked: isCommentChecked
    },
    {
      id: 'repost',
      name: 'repost',
      label: 'Repost',
      isChecked: isRepostChecked
    }
  ]);

  const [streamValidationOptions, setValidationOptions] = useState<
    Array<IOptionValidationCheckbox>
  >([
    {
      id: 'validated',
      name: 'validated',
      label: 'Validated',
      isChecked: isValidationChecked
    },
    {
      id: 'unvalidated',
      name: 'unvalidated',
      label: 'Unvalidated',
      isChecked: isUnValidatedChecked
    }
  ]);

  const [streamContentTypeOptions, setContentTypeOptions] = useState<
    Array<IOptionPostTypeCheckbox>
  >([
    {
      id: 'text',
      name: 'text',
      label: 'Text',
      isChecked: isContentTextChecked
    },
    {
      id: 'image',
      name: 'image',
      label: 'Image',
      isChecked: isContentImageChecked
    },
    {
      id: 'video',
      name: 'video',
      label: 'Video',
      isChecked: isContentVideoChecked
    },
    {
      id: 'others',
      name: 'others',
      label: 'Others',
      isChecked: isContentOthersChecked
    }
  ]);

  const [streamRatingOptions, setRatingOptions] = useState<
    Array<IOptionRatingCheckbox>
  >([
    {
      id: 1,
      name: 1,
      label: '1 ⭐️',
      isChecked: userRating.includes(1)
    },
    {
      id: 2,
      name: 2,
      label: '2 ⭐️⭐️',
      isChecked: userRating.includes(2)
    },
    {
      id: 3,
      name: 3,
      label: '3 ⭐️⭐️⭐️',
      isChecked: userRating.includes(3)
    },
    {
      id: 4,
      name: 4,
      label: '4 ⭐️⭐️⭐️⭐️',
      isChecked: userRating.includes(4)
    },
    {
      id: 5,
      name: 5,
      label: '5 ⭐️⭐️⭐️⭐️⭐️',
      isChecked: userRating.includes(5)
    }
  ]);

  const [streams, setStreams] = useState<IRawPostmadeOutputWithPagination>(
    streamsCommentingToPost
  );

  const [queryStringBooleanOperatorLocal, setQueryStringBooleanOperatorLocal] =
    useState<TStringOperator>(queryStringBooleanOperator);

  const handleChangeKeywordMode = (event: any) => {
    setQueryStringBooleanOperatorLocal(event.target.value);
  };

  const handleSearchIncludes = (value: string[]) => {
    const removedDobleSpaceStrings = value.map((text) =>
      correctDoubleSpaces(text)
    );
    setIncludeKeywordsLocal(removedDobleSpaceStrings);
  };

  const handleSearchExcludes = (value: string[]) => {
    const removedDobleSpaceStrings = value.map((text) =>
      correctDoubleSpaces(text)
    );
    setExcludeKeywordsLocal(removedDobleSpaceStrings);
  };

  const handleChangeOption = (prev, optionId) =>
    prev.map((option) => {
      if (option.id === optionId)
        return { ...option, isChecked: !option.isChecked };
      return option;
    });

  const handleClickSentiment = (optionId: TSentiment) => {
    setSentimentOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickStreamType = (optionId: TPostOwnership) => {
    setStreamTypeOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickTalkType = (optionId: TTalkType) => {
    setTalkTypeOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickValidation = (optionId: TValidation) => {
    setValidationOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickContentType = (optionId: TContentType) => {
    setContentTypeOptions((prev) => handleChangeOption(prev, optionId));
  };

  const handleClickRating = (optionId: string) => {
    setRatingOptions((prev) => handleChangeOption(prev, parseInt(optionId)));
  };

  const handleChangeConfidenceScoreMin = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    event.persist();
    let value = parseFloat(event.target.value);
    if (value > 1) value = 1;
    if (value < 0) value = 0;
    setSentimentConfidenceLevelMinLocal(value);
  };

  const handleChangeConfidenceScoreMax = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    event.persist();
    let value = parseFloat(event.target.value);
    if (value > 1) value = 1;
    if (value < 0) value = 0;
    setSentimentConfidenceLevelMaxLocal(value);
  };

  const handleDiscard = () => {
    setIncludeKeywordsLocal([]);
    setExcludeKeywordsLocal([]);
    setUsernameLocal('');
    setIncludeLabelListLocal([]);
    setExcludeLabelListLocal([]);
    setSentimentConfidenceLevelMinLocal(0);
    setSentimentConfidenceLevelMaxLocal(1);
    setSelectedProductsLocal([]);
    setStreams({
      result: [],
      totalRows: 0,
      totalPages: 0,
      page: 1,
      limit: 20
    });
    setSentimentOptions([
      {
        id: 'positive',
        name: 'positive',
        label: 'Positive',
        isChecked: false
      },
      {
        id: 'neutral',
        name: 'neutral',
        label: 'Neutral',
        isChecked: false
      },
      {
        id: 'negative',
        name: 'negative',
        label: 'Negative',
        isChecked: false
      }
    ]);
    setStreamTypeOptions([
      {
        id: 'postmade',
        name: 'postmade',
        label: 'Postmade',
        isChecked: false
      },
      {
        id: 'talk',
        name: 'talk',
        label: 'Talk',
        isChecked: false
      },
      {
        id: 'reply',
        name: 'reply',
        label: 'Reply',
        isChecked: false
      }
    ]);
    setValidationOptions([
      {
        id: 'validated',
        name: 'validated',
        label: 'Validated',
        isChecked: false
      },
      {
        id: 'unvalidated',
        name: 'unvalidated',
        label: 'Unvalidated',
        isChecked: false
      }
    ]);
    setContentTypeOptions([
      {
        id: 'text',
        name: 'text',
        label: 'Text',
        isChecked: false
      },
      {
        id: 'image',
        name: 'image',
        label: 'Image',
        isChecked: false
      },
      {
        id: 'video',
        name: 'video',
        label: 'Video',
        isChecked: false
      },
      {
        id: 'others',
        name: 'others',
        label: 'Others',
        isChecked: false
      }
    ]);
    setQueryStringBooleanOperatorLocal('and');
    setLanguageListLocal([]);
    setRatingOptions([
      {
        id: 1,
        name: 1,
        label: '1 ⭐️',
        isChecked: false
      },
      {
        id: 2,
        name: 2,
        label: '2 ⭐️⭐️',
        isChecked: false
      },
      {
        id: 3,
        name: 3,
        label: '3 ⭐️⭐️⭐️',
        isChecked: false
      },
      {
        id: 4,
        name: 4,
        label: '4 ⭐️⭐️⭐️⭐️',
        isChecked: false
      },
      {
        id: 5,
        name: 5,
        label: '5 ⭐️⭐️⭐️⭐️⭐️',
        isChecked: false
      }
    ]);
    setSelectAllPrimaryLocal(false);
    setTalkTypeOptions([
      {
        id: 'post',
        name: 'post',
        label: 'Post',
        isChecked: false
      },
      {
        id: 'comment',
        name: 'comment',
        label: 'Comment',
        isChecked: false
      },
      {
        id: 'repost',
        name: 'repost',
        label: 'Repost',
        isChecked: false
      }
    ]);
    setCommentingToPostDateRangeLocal(initialState.commentingToPostDateRange);
    setIncludeLabelCommentingToPost(initialState.commentingToPostLabelList);
  };

  // for date range label
  const dateRangeOptionActive = useAppSelector(
    (state) => state.analyticArguments.dateRangeOptionActive
  );

  const dateRangeLabel = () => {
    // if (dateRangeOptionActive.id !== 'custom') {
    //   return dateRangeOptionActive.label;
    // }
    return `${moment(commentingToPostDateRangeLocal.start).format(
      'L HH:mm'
    )} - ${moment(commentingToPostDateRangeLocal.end).format('L HH:mm')}`;
  };

  const handleDone = () => {
    // const sentiments = sentimentOptions
    //   .filter((sentiment) => sentiment.isChecked)
    //   .map((sen) => sen.id);
    //
    dispatch(
      reducerUpdateCommentingToPostDateRange(commentingToPostDateRangeLocal)
    );
    dispatch(
      reducerUpdateCommentingToPostLabelList(includeLabelCommentingToPost)
    );
    dispatch(
      reducerUpdateAdvanceSearch({
        includeKeywords: includeKeywordsLocal,
        excludeKeywords: excludeKeywordsLocal,
        fromUsername: usernameLocal,
        sentiment: sentimentOptions
          .filter((sentiment) => sentiment.isChecked)
          .map((sentiment) => sentiment.id),
        postOwnership: streamTypeOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        contentTypeList: streamContentTypeOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        validationList: streamValidationOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        talkType: talkTypeOptions
          .filter((type) => type.isChecked)
          .map((type) => type.id),
        labelList: includeLabelListLocal.map((label) => label.id),
        excludeLabelList: excludeLabelListLocal.map((label) => label.id),
        sentimentConfidenceLevelMin: sentimentConfidenceLevelMinLocal,
        sentimentConfidenceLevelMax: sentimentConfidenceLevelMaxLocal,
        showEmptyLabel: showEmptyLabelLocal,
        replyToOriginalId: selectedProductsLocal.map(
          (stream) => stream.originalId
        ),
        streamsCommentingToPost: streams,
        selectedOriginalToPost: selectedProductsLocal,
        searchOriginalToPost: debouncedState,
        queryStringBooleanOperator: queryStringBooleanOperatorLocal,
        languageList: languageListLocal.map((item) => item.language),
        userRating: streamRatingOptions
          .filter((rating) => rating.isChecked)
          .map((rating) => rating.id),
        selectAllPrimaryPost: selectAllPrimaryLocal,
        postMadeType: 'talk'
      })
    );
    onClose();
  };

  const [debouncedState, setDebouncedState] = useDebounce('');
  const [searchFormValue, setSearchFormValue] = useState('');

  const {
    data: streamsCommentingToPostData,
    loading: loadingStreamsCommentingToPost
  } = useGetEcommerceStreamCommentingToProduct({
    skip: expanded !== 'commenting_to_post',
    variables: {
      projectId: projectId,
      name: debouncedState
    }
  });

  const handleChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    const keyword = event.target.value;
    setSearchFormValue(keyword);
    setDebouncedState(() => keyword);
  };

  const handleSelectedProductsChange = (
    products: IEcommerceProductHierarchyItem[]
  ) => {
    setSelectedProductsLocal(products);
  };

  // const handleChangePage = (_: any, newPage: number) => {
  //   setPage(newPage);
  //   refetchContentTopTalkPostmade({
  //     ...finalPayload,
  //     includeKeywords: debouncedState === '' ? [] : [debouncedState],
  //     labelList: includeLabelCommentingToPost.map((label) => label.id),
  //     talkType: ['post'],
  //     limit,
  //     page: newPage
  //   });
  // };

  // const handleChangeLimit = (e: SelectChangeEvent<number>) => {
  //   const newLimit = Number(e.target.value);
  //   setLimit(newLimit);

  //   if (page !== 1) setPage(1);
  //   refetchContentTopTalkPostmade({
  //     ...finalPayload,
  //     includeKeywords: debouncedState === '' ? [] : [debouncedState],
  //     labelList: includeLabelCommentingToPost.map((label) => label.id),
  //     talkType: ['post'],
  //     limit: newLimit,
  //     page: 1
  //   });
  // };

  // const handleDeleteSearch = () => {
  //   setSearchFormValue('');
  //   setDebouncedState(() => '');
  // };

  const { dateRangeFormatted, objectIdList } = useAppSelector(
    (state) => state.analyticArguments
  );

  const granularity: IGranularity = {
    unit: 'day',
    value: 1
  };

  // const isOriginalPostSelected = (id: string) =>
  //   selectedProductsLocal.findIndex((obj) => obj.originalId === id) !== -1;

  // const totalSelectedPost = selectedProductsLocal.length;
  // const totalRowsPerPage = streams.result.length;

  // const handleClickOriginalPost = function (
  //   label: IEcommerceProductHierarchyItem
  // ) {
  //   const selectedIndex = selectedProductsLocal.findIndex(
  //     (obj) => obj.originalId === label.originalId
  //   );
  //   let newSelected: IEcommerceProductHierarchyItem[] = [];
  //   if (selectedIndex === -1) {
  //     newSelected = newSelected.concat(selectedProductsLocal, label);
  //   } else if (selectedIndex === 0) {
  //     newSelected = newSelected.concat(selectedProductsLocal.slice(1));
  //   } else if (selectedIndex === selectedProductsLocal.length - 1) {
  //     newSelected = newSelected.concat(selectedProductsLocal.slice(0, -1));
  //   } else if (selectedIndex > 0) {
  //     newSelected = newSelected.concat(
  //       selectedProductsLocal.slice(0, selectedIndex),
  //       selectedProductsLocal.slice(selectedIndex + 1)
  //     );
  //   }
  //   setSelectedProductsLocal(newSelected);
  // };

  // const handleClickSelectAllPosts = (
  //   e: ChangeEvent<HTMLInputElement>,
  //   checked: boolean
  // ) => {
  //   if (checked) {
  //     setSelectedOriginalToPostLocal(streams.result);
  //   } else {
  //     if (selectAllPrimaryLocal) setSelectAllPrimaryLocal(false);
  //     setSelectedOriginalToPostLocal([]);
  //   }
  // };

  const fillAdvanceSearchEcommerce = useMemo(() => {
    return fillParamAdvanceSearchEmpty(initialState);
  }, [initialState]);

  const timezone = useAppSelector((state) => state.users.project.timezone);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [commentingToPostDateRangeLocal, setCommentingToPostDateRangeLocal] =
    useState<IDateRange>(commentingToPostDateRange);

  const commentingToPostFormattedDateRange = useMemo(() => {
    return {
      start: moment(commentingToPostDateRangeLocal.start).format(
        'YYYY-MM-DD HH:mm:ss'
      ),
      end: moment(commentingToPostDateRangeLocal.end).format(
        'YYYY-MM-DD HH:mm:ss'
      )
    };
  }, [commentingToPostDateRangeLocal]);

  const finalPayload = {
    ...fillAdvanceSearchEcommerce,
    projectId,
    ...commentingToPostFormattedDateRange,
    objectList: objectIdListLocal ?? objectIdList,
    granularity,
    timezone
  };

  const handleClickPostTimeframe = () => {
    setOpenDatePicker(true);
  };

  const handleClosePostTimeframe = () => {
    setOpenDatePicker(false);
  };

  const handleChangeTimeframe = (dateRange: IDateRange): void => {
    setCommentingToPostDateRangeLocal(dateRange);
    setOpenDatePicker(false);
  };

  // const {
  //   refetch: refetchContentTopTalkPostmade,
  //   loading: contentTopTalkPostmadeLoading
  // } = useQuery(GET_CONTENT_TOP_TALK_POSTMADE_PAGINATION, {
  //   variables: {
  //     ...finalPayload,
  //     includeKeywords: debouncedState === '' ? [] : [debouncedState],
  //     labelList: includeLabelCommentingToPost.map((label) => label.id),
  //     talkType: ['post'],
  //     limit: limit,
  //     page: 1
  //   },
  //   onCompleted: ({ content_getTopTalkPostMadeWithPagination }) => {
  //     setStreams(content_getTopTalkPostMadeWithPagination);
  //     // setSelectAllPrimaryLocal(false);
  //   },
  //   fetchPolicy: 'network-only'
  // });

  const [
    getPostmadeIds,
    { data: postmadeIdsData, loading: postmadeIdsLoading }
  ] = useLazyQuery<{
    content_getStreamOriginalIdPostmade: string[];
  }>(GET_POSTMADE_STREAM_ID, {
    fetchPolicy: 'cache-first',
    onError: () => {
      handleClickAlert({
        message: 'Error selecting all post, please try again',
        horizontal: 'center',
        vertical: 'top',
        severity: 'error'
      });
      setSelectAllPrimaryLocal(false);
    }
  });

  const handleClickSelectAllPrimary = (selected: boolean) => {
    if (!selected) {
      setSelectAllPrimaryLocal(false);
      return;
    }
    setSelectAllPrimaryLocal(true);
    getPostmadeIds({
      variables: {
        ...finalPayload,
        postOwnership: ['talk'],
        talkType: ['post'],
        includeKeywords: debouncedState === '' ? [] : [debouncedState],
        labelList: includeLabelCommentingToPost.map((label) => label.id),
        page: 1,
        limit: 100
      }
    });
  };

  const renderLanguageOption = (
    props: React.HTMLAttributes<HTMLLIElement>,
    option: ILanguage,
    { selected }: AutocompleteRenderOptionState
  ) => {
    const handleChange = (
      e: ChangeEvent<HTMLInputElement>,
      checked: boolean
    ) => {
      if (option.language === 'all') {
        if (checked)
          setLanguageListLocal(languages?.languages_getLanguagesV2 ?? []);
        else setLanguageListLocal([]);
      }
    };

    const isIndeterminate =
      languageListLocal.length > 0 &&
      languageListLocal.length !==
        (languages?.languages_getLanguagesV2.length ?? 0);

    const isChecked =
      option.language !== 'all'
        ? selected
        : languageListLocal.length ===
          (languages?.languages_getLanguagesV2.length ?? 0);

    return (
      <Box
        {...props}
        key={option.language}
        component="li"
        sx={{
          '&.MuiAutocomplete-option[aria-selected="true"], &.MuiAutocomplete-option[aria-selected="true"].Mui-focused':
            {
              backgroundColor: 'white'
            }
        }}
      >
        <Checkbox
          size="small"
          style={{ marginRight: 8 }}
          checked={isChecked}
          onChange={handleChange}
          indeterminate={option.language === 'all' && isIndeterminate}
        />
        {option.name}
      </Box>
    );
  };

  const renderLanguageTags = (
    values: ILanguage[],
    getTagProps: AutocompleteRenderGetTagProps
  ): ReactNode => {
    if (values.length > 6) {
      return (
        <>
          {values.slice(0, 6).map((option: ILanguage, index: number) => (
            <Chip
              key={`${option}-${index}-includes`}
              variant="outlined"
              label={<Typography>{option.name}</Typography>}
              size="small"
              {...getTagProps({ index })}
            />
          ))}
          <Chip
            key={`rest`}
            variant="outlined"
            label={<Typography>+{values.length - 6}</Typography>}
            size="small"
          />
        </>
      );
    }
    return values.map((option: ILanguage, index: number) => (
      <Chip
        key={`${option}-${index}-includes`}
        variant="outlined"
        label={<Typography>{option.name}</Typography>}
        size="small"
        {...getTagProps({ index })}
      />
    ));
  };

  const handleSwapIncludeExclude = () => {
    const temp = includeKeywordsLocal;
    setIncludeKeywordsLocal(excludeKeywordsLocal);
    setExcludeKeywordsLocal(temp);
  };

  useEffect(() => {
    if (debouncedState !== searchFormValue) {
      if (page !== 1) setPage(1);

      // TODO: replace with ecommerce query

      // refetchContentTopTalkPostmade({
      //   ...finalPayload,
      //   includeKeywords: debouncedState === '' ? [] : [debouncedState],
      //   labelList: includeLabelCommentingToPost.map((label) => label.id),
      //   talkType: ['post'],
      //   limit,
      //   page: 1
      // });
    }
  }, [debouncedState]);

  useEffect(() => {
    setIncludeKeywordsLocal(includeKeywords);
  }, [includeKeywords]);

  useEffect(() => {
    setUsernameLocal(fromUsername);
  }, [fromUsername]);

  const tfStyle = {
    '& .MuiButtonBase-root.MuiAutocomplete-clearIndicator': {
      color: 'blue',
      visibility: 'visible'
    }
  };

  const keywordRef = useRef(null);

  return (
    <>
      <Dialog onClose={onClose} open={open} fullWidth maxWidth={'md'}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{
            m: theme.spacing(3, 3, 0),
            p: theme.spacing(2, 2, 0, 2)
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: 600,
              fontSize: 20,
              textAlign: 'left'
            }}
          >
            Advance Search
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            m: { mb: theme.spacing(1, 2) }
          }}
        >
          <Accordion
            expanded={expanded === 'more_filters'}
            onChange={handleChangeAccordion('more_filters')}
          >
            {expanded === 'more_filters' ? null : (
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography
                  sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                >
                  More Filters
                </Typography>
                <Typography
                  sx={{
                    fontSize: 14,
                    color: 'text.secondary'
                  }}
                >
                  Show
                </Typography>
              </AccordionSummary>
            )}
            <AccordionDetails>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                    Includes
                  </Typography>
                  <CustomAutocomplete
                    multiple
                    id="keyword-includes"
                    size="small"
                    options={[]}
                    defaultValue={[]}
                    freeSolo
                    ref={keywordRef}
                    value={includeKeywordsLocal}
                    renderTags={(values: Array<any>, getTagProps) =>
                      values.map((option: string, index: number) => (
                        <Chip
                          key={`${option}-${index}-includes`}
                          variant="outlined"
                          label={<Typography>{option}</Typography>}
                          size="small"
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    onChange={(_e, value) => {
                      handleSearchIncludes(value);
                    }}
                    forcePopupIcon={false}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="includes"
                        variant="outlined"
                        size="small"
                        autoComplete="off"
                        placeholder="Separated by Enter"
                        sx={{ tfStyle }}
                        onPaste={(event) => {
                          const keywords = event.clipboardData.getData('text');
                          const splitKeyword = keywords.split(',');
                          const trimAndFilterKeyword = splitKeyword
                            .filter((word) => word.trim().length > 1)
                            .map((word) => word.trim());

                          const value = [
                            ...includeKeywordsLocal,
                            ...trimAndFilterKeyword
                          ];
                          handleSearchIncludes(value);
                        }}
                      />
                    )}
                  />
                </Grid>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-end"
                  width="100%"
                  py={1}
                >
                  <IconButton
                    size="small"
                    onClick={handleSwapIncludeExclude}
                    sx={{
                      margin: theme.spacing(0, 1.5),
                      border: '1px solid #009FE333',
                      backgroundColor: '#E7F3F7',
                      marginBottom: '-20px',
                      borderRadius: '8px'
                    }}
                  >
                    <SwapVertIcon />
                  </IconButton>
                </Stack>
                <Grid item sx={{ pt: '0 !important' }} xs={12}>
                  <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                    Excludes
                  </Typography>
                  <CustomAutocomplete
                    multiple
                    id="keyword-includes"
                    size="small"
                    options={[]}
                    defaultValue={[]}
                    freeSolo
                    value={excludeKeywordsLocal}
                    renderTags={(values: Array<any>, getTagProps) =>
                      values.map((option: string, index: number) => (
                        <Chip
                          key={`${option}-${index}-includes`}
                          variant="outlined"
                          label={<Typography>{option}</Typography>}
                          size="small"
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    onChange={(_e, value) => {
                      handleSearchExcludes(value);
                    }}
                    forcePopupIcon={false}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="includes"
                        variant="outlined"
                        size="small"
                        autoComplete="off"
                        placeholder="Separated by Enter"
                        onPaste={(event) => {
                          const keywords = event.clipboardData.getData('text');
                          const splitKeyword = keywords.split(',');
                          const trimAndFilterKeyword = splitKeyword
                            .filter((word) => word.trim().length > 1)
                            .map((word) => word.trim());
                          const value = [
                            ...excludeKeywordsLocal,
                            ...trimAndFilterKeyword
                          ];
                          handleSearchExcludes(value);
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item lg={12}>
                  <Typography
                    id="keywordMode"
                    sx={{ mb: theme.spacing(0.5) }}
                    variant="h5"
                  >
                    Mode for Includes & Excludes
                  </Typography>
                  <Stack direction="row" flexWrap="wrap" gap={2}>
                    <Radio
                      checked={queryStringBooleanOperatorLocal === 'and'}
                      value="and"
                      size="small"
                      inputProps={{ 'aria-label': 'And' }}
                      onChange={handleChangeKeywordMode}
                      checkedIcon={
                        <ChipCustom
                          variant="filled"
                          deleteIcon={<CheckIcon />}
                          label={
                            <Stack direction="row" alignItems="center">
                              <RadioButtonChecked
                                sx={{
                                  mr: 1,
                                  width: 16,
                                  height: 16,
                                  color: theme.palette.primary.main
                                }}
                              />{' '}
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  color: theme.palette.primary.main,
                                  fontSize: 13,
                                  fontWeight: 'normal'
                                }}
                              >
                                And
                              </Typography>
                            </Stack>
                          }
                          size="small"
                          sx={{
                            background: theme.palette.primary.light,
                            padding: '10px 56px 10px 8px'
                          }}
                          colorChip={theme.palette.common.black}
                        />
                      }
                      icon={
                        <ChipCustom
                          variant="filled"
                          deleteIcon={<CheckIcon />}
                          label={
                            <Stack direction="row" alignItems="center">
                              <PanoramaFishEyeIcon
                                sx={{
                                  mr: 1,
                                  width: 16,
                                  height: 16,
                                  color: theme.palette.primary.main
                                }}
                              />{' '}
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  color: theme.palette.primary.main,
                                  fontSize: 13,
                                  fontWeight: 'normal'
                                }}
                              >
                                And
                              </Typography>
                            </Stack>
                          }
                          size="small"
                          sx={{
                            background: theme.palette.primary.light,
                            padding: '10px 56px 10px 8px'
                          }}
                          colorChip={theme.palette.common.black}
                        />
                      }
                    />
                    <Radio
                      checked={queryStringBooleanOperatorLocal === 'or'}
                      value="or"
                      size="small"
                      inputProps={{ 'aria-label': 'Or' }}
                      onChange={handleChangeKeywordMode}
                      checkedIcon={
                        <ChipCustom
                          variant="filled"
                          deleteIcon={<CheckIcon />}
                          label={
                            <Stack direction="row" alignItems="center">
                              <RadioButtonChecked
                                sx={{
                                  mr: 1,
                                  width: 16,
                                  height: 16,
                                  color: theme.palette.primary.main
                                }}
                              />{' '}
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  color: theme.palette.primary.main,
                                  fontSize: 13,
                                  fontWeight: 'normal'
                                }}
                              >
                                Or
                              </Typography>
                            </Stack>
                          }
                          size="small"
                          sx={{
                            background: theme.palette.primary.light,
                            padding: '10px 56px 10px 8px'
                          }}
                          colorChip={theme.palette.common.black}
                        />
                      }
                      icon={
                        <ChipCustom
                          variant="filled"
                          deleteIcon={<CheckIcon />}
                          label={
                            <Stack direction="row" alignItems="center">
                              <PanoramaFishEyeIcon
                                sx={{
                                  mr: 1,
                                  width: 16,
                                  height: 16,
                                  color: theme.palette.primary.main
                                }}
                              />{' '}
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  color: theme.palette.primary.main,
                                  fontSize: 13,
                                  fontWeight: 'normal'
                                }}
                              >
                                Or
                              </Typography>
                            </Stack>
                          }
                          size="small"
                          sx={{
                            background: theme.palette.primary.light,
                            padding: '10px 56px 10px 8px'
                          }}
                          colorChip={theme.palette.common.black}
                        />
                      }
                    />
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                    Username
                  </Typography>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder="@example"
                    onChange={(e) => setUsernameLocal(e.target.value)}
                    value={usernameLocal}
                  />
                </Grid>
                {/* <Grid item xs={12}>
                  <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                    Languages
                  </Typography>
                  <Autocomplete<ILanguage, true, false, false>
                    size="small"
                    multiple
                    id="language-list"
                    options={[
                      {
                        language: 'all',
                        name: 'Select All'
                      } as ILanguage,
                      ...(languages?.languages_getLanguagesV2 ?? [])
                    ]}
                    loading={loadingLanguages}
                    disableCloseOnSelect
                    fullWidth
                    value={languageListLocal}
                    onChange={(_: SyntheticEvent, newValue) => {
                      // Check if the new selection includes the "all" option
                      const hasAllOption = newValue.some(
                        (lang) => lang.language === 'all'
                      );

                      if (hasAllOption) {
                        const allSelected =
                          languageListLocal.length ===
                          (languages?.languages_getLanguagesV2.length ?? 0);
                        setLanguageListLocal(
                          allSelected
                            ? []
                            : languages?.languages_getLanguagesV2 ?? []
                        );
                      } else {
                        setLanguageListLocal(newValue as ILanguage[]);
                      }
                    }}
                    ListboxProps={{ style: { padding: 0 } }}
                    getOptionLabel={(option) => option.name}
                    renderTags={renderLanguageTags}
                    renderOption={renderLanguageOption}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={
                          languageListLocal.length <= 0 ? 'All languages' : null
                        }
                      />
                    )}
                  />
                </Grid> */}
                {/* <Grid item lg={12}>
                  <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                    Sentiment
                  </Typography>
                  <Stack direction="row" flexWrap="wrap" alignItems="center">
                    {sentimentOptions.map((option) => (
                      <CheckboxCustomNl
                        {...option}
                        key={option.id}
                        onClick={handleClickSentiment}
                      />
                    ))}
                  </Stack>
                </Grid> */}
                <Grid item lg={12}>
                  <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                    Sentiment Validation
                  </Typography>
                  <Stack direction="row" flexWrap="wrap" alignItems="center">
                    {streamValidationOptions.map((option) => (
                      <CheckboxCustomNl
                        {...option}
                        key={option.id}
                        onClick={handleClickValidation}
                      />
                    ))}
                  </Stack>
                </Grid>
                {/* <Grid item lg={12}>
                  <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                    Review Rating
                  </Typography>
                  <Stack
                    direction="row"
                    alignItems="center"
                    flexWrap="wrap"
                    rowGap={2}
                  >
                    {streamRatingOptions.map((option) => (
                      <CheckboxCustomNl
                        {...option}
                        id={option.id.toString()}
                        name={option.name.toString()}
                        key={option.id}
                        onClick={handleClickRating}
                      />
                    ))}
                  </Stack>
                </Grid> */}
                {/* <Grid item xs={12}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ mb: theme.spacing(1) }}
                  >
                    <Typography variant="h5">Include Label</Typography>
                    {includeLabelListLocal.length > 0 && (
                      <Button
                        size="small"
                        variant="outlined"
                        sx={{ maxHeight: theme.spacing(3.5) }}
                        onClick={handleClickLabelInclude}
                      >
                        Select +
                      </Button>
                    )}
                  </Stack>
                  <Box
                    sx={{
                      background: '#FBFBFB',
                      borderRadius: theme.spacing(1),
                      maxHeight: theme.spacing(9 * 4)
                    }}
                  >
                    {includeLabelListLocal.length < 1 && (
                      <Stack
                        direction="row"
                        flexWrap="wrap"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <CheckboxCustomNl
                          id="unlabeled"
                          label="Unlabeled"
                          name="setShowEmptyLabelLocal"
                          isChecked={showEmptyLabelLocal}
                          onClick={() =>
                            setShowEmptyLabelLocal(!showEmptyLabelLocal)
                          }
                        />
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleClickLabelInclude}
                          sx={{ margin: theme.spacing(2, 1.5) }}
                        >
                          Select Label
                        </Button>
                      </Stack>
                    )}
                    <Box
                      sx={{
                        maxHeight: theme.spacing(25),
                        overflow: 'auto'
                      }}
                    >
                      {includeLabelListLocal.length > 0 &&
                        includeLabelListLocal.map((label) => (
                          <Box
                            sx={{
                              padding: theme.spacing(1, 2)
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              spacing={1}
                            >
                              <Box sx={{ maxWidth: '70%' }}>
                                <Typography>{label.displayName}</Typography>
                              </Box>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={3}
                              >
                                <Stack direction={'row'}>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 500,
                                      fontSize: 13
                                    }}
                                  >
                                    {moment(label.createdAt).format(
                                      'ddd, MMM DD YYYY, HH:mm'
                                    )}
                                  </Typography>
                                </Stack>
                                <FabSmall
                                  size="small"
                                  sx={{
                                    marginLeft: theme.spacing(2)
                                  }}
                                >
                                  <DeleteIcon
                                    sx={{
                                      fontSize: theme.spacing(1.5)
                                    }}
                                    onClick={() =>
                                      setIncludeLabelListLocal((prev) =>
                                        prev.filter(
                                          (prevLabel) =>
                                            prevLabel.id !== label.id
                                        )
                                      )
                                    }
                                  />
                                </FabSmall>
                              </Stack>
                            </Stack>
                          </Box>
                        ))}
                    </Box>
                  </Box>
                </Grid> */}
                <Grid item xs={12}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ mb: theme.spacing(1) }}
                  >
                    <Typography variant="h5">Exclude Label</Typography>
                    {excludeLabelListLocal.length > 0 && (
                      <Button
                        size="small"
                        variant="outlined"
                        sx={{ maxHeight: theme.spacing(3.5) }}
                        onClick={handleClickLabelExclude}
                      >
                        Select +
                      </Button>
                    )}
                  </Stack>
                  <Box
                    sx={{
                      background: '#FBFBFB',
                      borderRadius: theme.spacing(1),
                      maxHeight: theme.spacing(9 * 4)
                    }}
                  >
                    {excludeLabelListLocal.length < 1 && (
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                      >
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleClickLabelExclude}
                          sx={{ margin: theme.spacing(2, 1.5) }}
                        >
                          Select Label
                        </Button>
                      </Stack>
                    )}
                    <Box
                      sx={{
                        maxHeight: theme.spacing(25),
                        overflow: 'auto'
                      }}
                    >
                      {excludeLabelListLocal.length > 0 &&
                        excludeLabelListLocal.map((label) => (
                          <Box
                            sx={{
                              padding: theme.spacing(1, 2)
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              spacing={1}
                            >
                              <Box sx={{ maxWidth: '70%' }}>
                                <Typography>{label.displayName}</Typography>
                              </Box>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={3}
                              >
                                <Stack direction={'row'}>
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 500,
                                      fontSize: 13
                                    }}
                                  >
                                    {moment(label.createdAt).format(
                                      'ddd, MMM DD YYYY, HH:mm'
                                    )}
                                  </Typography>
                                </Stack>
                                <FabSmall
                                  size="small"
                                  sx={{
                                    marginLeft: theme.spacing(2)
                                  }}
                                >
                                  <DeleteIcon
                                    sx={{
                                      fontSize: theme.spacing(1.5)
                                    }}
                                    onClick={() =>
                                      setExcludeLabelListLocal((prev) =>
                                        prev.filter(
                                          (prevLabel) =>
                                            prevLabel.id !== label.id
                                        )
                                      )
                                    }
                                  />
                                </FabSmall>
                              </Stack>
                            </Stack>
                          </Box>
                        ))}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          {/* <Accordion
            expanded={expanded === 'commenting_to_post'}
            onChange={handleChangeAccordion('commenting_to_post')}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
                variant="h5"
              >
                Commenting to Product
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  color: 'text.secondary'
                }}
              >
                {expanded === 'commenting_to_post' ? 'Hide' : 'Show'}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableCommentingToProduct
                data={
                  streamsCommentingToPostData?.ecommerceProductManagement_getProductHierarchy ||
                  []
                }
                loading={loadingStreamsCommentingToPost}
                searchValue={searchFormValue}
                handleChangeSearchValue={handleChangeSearch}
                selectedProducts={selectedProductsLocal}
                onSelectedProductsChange={handleSelectedProductsChange}
              />
            </AccordionDetails>
          </Accordion> */}
          {/* <Accordion
            expanded={expanded === 'confidence_score'}
            onChange={handleChangeAccordion('confidence_score')}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{ width: { xs: '85%', md: '95%' }, flexShrink: 0 }}
              >
                Confidence Score
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  color: 'text.secondary'
                }}
              >
                {expanded === 'confidence_score' ? 'Hide' : 'Show'}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid item lg={12}>
                <Grid container spacing={3}>
                  <Grid item lg={6}>
                    <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                      From
                    </Typography>
                    <CustomInput
                      value={sentimentConfidenceLevelMinLocal}
                      fullWidth
                      onChange={handleChangeConfidenceScoreMin}
                      type="number"
                      inputProps={{ min: 0, max: 1, step: '0.1' }}
                    />
                  </Grid>
                  <Grid item lg={6}>
                    <Typography sx={{ mb: theme.spacing(0.5) }} variant="h5">
                      To
                    </Typography>
                    <CustomInput
                      value={sentimentConfidenceLevelMaxLocal}
                      fullWidth
                      onChange={handleChangeConfidenceScoreMax}
                      type="number"
                      inputProps={{ min: 0, max: 1, step: '0.1' }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion> */}
        </DialogContent>
        <DialogActions>
          <Stack
            spacing={2}
            justifyContent="center"
            display="flex"
            direction="row"
            sx={{ mt: theme.spacing(3) }}
          >
            <Button
              variant="outlined"
              sx={{
                width: theme.spacing(20)
              }}
              onClick={handleDiscard}
              size="medium"
            >
              Discard
            </Button>
            <Button
              variant="contained"
              sx={{
                width: theme.spacing(20)
              }}
              onClick={handleDone}
              size="medium"
              disabled={postmadeIdsLoading}
            >
              Done
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
      <ModalCustomTimeFrame
        onClose={handleClosePostTimeframe}
        onSet={handleChangeTimeframe}
        open={openDatePicker}
        initDateRange={commentingToPostDateRange}
      />
      <ModalSelectLabel
        title="Select Include Label"
        open={openLabelInclude}
        onClose={handleCloseLabelInclude}
        onSubmit={(labels) => {
          handleCloseLabelInclude();
          setIncludeLabelListLocal(labels);
        }}
        prevSelectedLabels={includeLabelListLocal}
        labelList={labelEcommerce}
      />
      <ModalSelectLabel
        title="Include Label for Commenting to Post"
        open={openLabelIncludeCommentingToPost}
        onClose={handleCloseLabelIncludeCommentingToPost}
        onSubmit={(labels) => {
          handleCloseLabelIncludeCommentingToPost();
          setIncludeLabelCommentingToPost(labels);
        }}
        prevSelectedLabels={includeLabelCommentingToPost}
        labelList={labelEcommerce}
      />
      <ModalSelectLabel
        title="Select Exclude Label"
        open={openLabelExclude}
        onClose={handleCloseLabelExclude}
        onSubmit={(labels) => {
          handleCloseLabelExclude();
          setExcludeLabelListLocal(labels);
        }}
        prevSelectedLabels={excludeLabelListLocal}
        labelList={labelEcommerce}
      />
    </>
  );
};

export default AdvanceSearchEcommerce;
